import { clearPageData } from "@playlive/adobe-analytics";
import { useEffect } from "react";
import { Outlet } from "react-router";

export function AnalyticsTracking() {
  useEffect(() => {
    return () => {
      clearPageData();
    };
  });

  return <Outlet />;
}
